export const useImageResize = () => {
    /**
     * Get Cloudflare resized image URL
     * @param imageUrl - The original image URL
     * @param width - Width in pixels (default: 25)
     * @param height - Height in pixels (default: 25) 
     * @param quality - Image quality 1-100 (default: 100)
     * @returns Cloudflare resized image URL
     */
    const getCloudflareResizedImage = (
        imageUrl: string, 
        width: number = 25, 
        height: number = 25, 
        quality: number = 100
    ): string => {
        if (!imageUrl) return '';
        
        const cloudflareBase = 'https://privacybee.com/cdn-cgi/image/';
        const resizeParams = `fit=scale-down,width=${width},height=${height},quality=${quality}`;
        
        return `${cloudflareBase}${resizeParams}/${imageUrl}`;
    };

    return {
        getCloudflareResizedImage,
    };
};
